export const req = [
    {
        titulo: 'Copia de documento de identidad', icono: '1'
    },
    {
        titulo: 'Certificado de afiliación a EPS', icono: '2'
    },
    {
        titulo: 'Hoja de vida enviada al correo', icono: '3'
    },
    {
        titulo: 'Firmar carta de compromiso interno de la Fundación', icono: '4'
    },
]